import { Reveal } from "../Reveal";
import Counter from "../Counter";
import { STATS, HONORS } from "../../lib/content";

export default function Impact() {
  return (
    <section id="impact" className="relative py-24 md:py-36" data-testid="impact-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="text-xs uppercase tracking-[0.25em] text-gold">Impact by Numbers</span>
              <h2 className="font-serif text-4xl md:text-6xl font-light mt-4 leading-tight text-foreground">
                Built from zero, <span className="text-gradient-royal italic">scaled nationally.</span>
              </h2>
            </div>
          </div>
        </Reveal>

        {/* bento */}
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={(i % 4) * 0.06}>
              <div className="h-full rounded-2xl border border-gold/15 bg-card p-7 hover:border-gold/40 transition-colors duration-500">
                <p className="font-serif text-5xl md:text-6xl text-gradient-gold leading-none">
                  <Counter to={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-4 text-sm font-medium text-foreground">{s.label}</p>
                <p className="mt-1 text-xs text-muted-foreground">{s.sub}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* honors */}
        <Reveal delay={0.1}>
          <div className="mt-16 rounded-2xl border border-royal/25 bg-[radial-gradient(ellipse_at_top_left,rgba(147,51,234,0.12),transparent_60%)] p-8 md:p-12">
            <h3 className="font-serif text-2xl md:text-3xl text-foreground mb-8">Selected Honors & Milestones</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-5">
              {HONORS.map((h) => (
                <div key={h} className="flex gap-4 items-start border-b border-gold/10 pb-5">
                  <span className="text-gold text-lg leading-none mt-1">✦</span>
                  <p className="text-sm text-muted-foreground leading-relaxed">{h}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
